import { Badge } from './ui/badge';

interface OrganizationBadgeProps {
  organizationName: string;
  className?: string;
}

export function OrganizationBadge({ organizationName, className }: OrganizationBadgeProps) {
  return (
    <Badge variant="outline" className={`text-sm font-normal px-3 py-0.5 ${className ?? ''}`}>
      {organizationName}
    </Badge>
  );
}
